import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { showReportDialog } from "@sentry/browser";
import norecord from "./norecord.png";
import "./style.css";

const ErrorBoundaryFallback = ({ eventId }) => {
  const { t } = useTranslation();
  const { runConfig } = window;
  const SENTRY_ENABLED = runConfig.isSentryEnabled;

  const feedbackLang = {
    title: t("boundary:feedback.title"),
    subtitle: t("boundary:feedback.subtitle"),
    subtitle2: t("boundary:feedback.subtitle2"),
    labelName: t("boundary:feedback.labelName"),
    labelEmail: t("boundary:feedback.labelEmail"),
    labelComments: t("boundary:feedback.labelComments"),
    labelClose: t("boundary:feedback.labelClose"),
    labelSubmit: t("boundary:feedback.labelSubmit"),
    errorGeneric: t("boundary:feedback.errorGeneric"),
    errorFormEntry: t("boundary:feedback.errorFormEntry"),
    successMessage: t("boundary:feedback.successMessage")
  };

  const feedback = () =>
    showReportDialog({
      eventId,
      ...feedbackLang,
      onLoad: () => {
        const elem = document.querySelector(".sentry-error-embed");
        elem.querySelector("textarea[name='comments']").attributes[
          "placeholder"
        ].value = t("boundary:feedback.placeholderComments");
      }
    });
  const refresh = () => window.location.reload();

  return (
    <div className="wrap">
      <div className="boundary">
        <img src={norecord} alt="Opps.." />
        <div className="name">Oppss</div>
        <div className="desc1">
          <Trans i18nKey="generic:went_wrong"></Trans>
        </div>
        <div className="desc2">
          <Trans i18nKey="generic:went_wrong_line_2"></Trans>
        </div>
        {SENTRY_ENABLED && (
          <button onClick={feedback} className="btn btn-primary me-2">
            <Trans i18nKey="generic:buttons.feedback"></Trans>
          </button>
        )}
        <button onClick={refresh} className="btn btn-secondary">
          <Trans i18nKey="generic:buttons.refresh"></Trans>
        </button>
      </div>
    </div>
  );
};

export default ErrorBoundaryFallback;
